<template>
  <div ref="target" class="news-list">
    <div class="left">
      <div class="top">
        <div class="top-carousel">
          <NewsCarousel :bannerList="bannerList" />
          <DomainList :domainList="domainList" />
        </div>
      </div>
      <div class="bottom">
        <NewsVideo :list="list" />
      </div>
    </div>
    <div class="middle">
      <PolicyNews :policyList="policyList" :domainList="domainList" />
    </div>
    <div class="right">
      <NoticeNews :noticeList="noticeList" :domainList="domainList" />
      <div class="notes">
        <NewsTests :testList="testList" />
      </div>
    </div>
  </div>
</template>

<script>
import DomainList from "../common/domain-list.vue";

import NewsVideo from "../newsvideo/news-video";
import NewsTests from "../newstests/news-tests";
import NewsCarousel from "../common/new-carousel";
import PolicyNews from "../common/policy-news.vue";
import NoticeNews from "../common/notice-news.vue";
import { findNewsVideo, findNewsTests } from "@/api/news";
import { useLazyData, useLazyNewsTests } from "@/hooks/index";
import { computed, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
export default {
  components: {
    NewsVideo,
    NewsTests,
    NewsCarousel,
    DomainList,
    PolicyNews,
    NoticeNews,
  },
  props: {
    policyList: {
      type: Object,
      default: () => {},
    },
    noticeList: {
      type: Object,
      default: () => {},
    },
    bannerList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const store = useStore();
    const clID = ref();
    const target = ref(null);
    let intervalId = null;
    let fugaozhongyi = [
      1253, 126, 1847, 2880, 1848, 2881, 129, 116, 123, 119, 1846, 2879, 3572,
      3575, 3573, 2882, 1850,
    ];

    function getRandomNumber(arr) {
      const randomIndex = Math.floor(Math.random() * arr.length);
      return arr[randomIndex];
    }
    intervalId = setInterval(() => {
      clID.value = getRandomNumber(fugaozhongyi);
    }, 3000);

    const { result } = useLazyData(target, () =>
      findNewsVideo({ clID: [clID.value] })
    );
    const { testList } = useLazyNewsTests(target, () =>
      findNewsTests({ clID: [clID.value] })
    );

    const domainList = computed(() => {
      let list = store.state.category.list.find(
        (items) => items.clID === clID.value
      );
      return list;
    });
    onUnmounted(() => {
      // 清除定时器
      if (intervalId) {
        clearInterval(intervalId);
      }
    });
    return { target, testList, list: result, domainList, NewsVideo };
  },
};
</script>

<style lang="less" scoped>
.news-list {
  height: 500px;
  //background: #f0e5e5;
  display: flex;
  justify-content: space-between;
  .left {
    width: 400px;
    height: 500px;
    display: flex;
    flex-direction: column;
    .top {
      width: 400px;
      height: 240px;
      .top-carousel {
        display: inline-block;
        width: 360px;
        height: 130px;
        margin-left: 20px;
        margin-right: 20px;
        margin-top: 15px;
        border-radius: 5px;
      }
    }

    .bottom {
      width: 400px;
      height: 250px;
    }
  }
  .middle {
    margin-top: 15px;
    width: 400px;
    overflow: hidden;
    border: 1px solid rgb(244, 244, 244);
    .policy {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      background: rgb(244, 244, 244);
      div {
        display: flex;
        align-items: center;
        i {
          display: inline-block;
          width: 3px;
          height: 20px;
          background: @shColor;
        }
        h3 {
          margin-left: 10px;
        }
      }
      a {
        display: flex;
        align-items: center;
        color: #999;
        &:hover {
          color: @shColor;
        }
      }
    }
    .policy-news {
      ul {
        width: 400px;
        margin-top: 5px;
        padding: 5px 5px 5px 5px;
        & :hover {
          color: @shColor;
          cursor: pointer;
        }
        a {
          display: inline-block;
          width: 400px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          padding-right: 10px;
        }
      }
    }
  }
  .right {
    margin-top: 15px;
    width: 400px;

    .notes {
    }
  }
}
</style>
